import { atom } from 'recoil';
import { Page } from '../types/app';
import { AuthUser } from '../types/authUser';
import { persistedAtom } from '../utils/persistence';
import { Key } from 'react';

export const isLoggedInState = persistedAtom('app.loggedIn', false);

export const sidenavIsPinnedState = persistedAtom('app.sidenav.pinned', true);
export const sidenavSectionsState = persistedAtom<Key[]>('app.sidenav.sections', []);

export const pageState = persistedAtom<string>('app.page', '');

export const previusPageState = atom<{ path: string; page?: Page }>({
  key: 'app.page.previus',
  default: undefined,
});

export const currentPageState = atom<{ path: string; page?: Page } | undefined>({
  key: 'app.page.current',
  default: undefined,
});

export const authUserState = persistedAtom<AuthUser | undefined>('app.auth.user', undefined);
